/* Kopi Blok — B2B employee landing controller
 * Reads the JSON config emitted by sections/kb-figma-b2b-landing.liquid and drives
 * the 3-step flow. The Airtable bridge (built separately) speaks the same JSON:
 * see ~/MCP/kopiblok-b2b-landing/API.md for the contract.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-kbl]');
  if (!root) return;

  /* ─────────────── config ─────────────── */
  var cfg;
  try { cfg = JSON.parse(root.querySelector('[data-kbl-config]').textContent); }
  catch (e) { console.error('[kbl] bad config JSON', e); return; }

  var T = cfg.texts || {};
  var trim = function (s) { return (s == null ? '' : String(s)).trim(); };
  var list = function (v) { return Array.isArray(v) ? v.map(trim).filter(Boolean) : trim(v).split(',').map(trim).filter(Boolean); };

  function normGift(g) {
    return {
      key: trim(g.key), title: trim(g.title), subtitle: trim(g.subtitle), badge: trim(g.badge),
      image: trim(g.image), product_handle: trim(g.product_handle), variant_id: trim(g.variant_id),
      airtable_id: trim(g.airtable_id), sold_out: !!g.sold_out,
      fields: Array.isArray(g.fields) ? g.fields.map(normField) : null
    };
  }
  function normField(f) {
    var out = {
      key: trim(f.key) || trim(f.label), type: trim(f.type) || 'text', label: trim(f.label),
      gifts: list(f.gifts), required: !!f.required, placeholder: trim(f.placeholder), hint: trim(f.hint),
      airtable: trim(f.airtable), style: trim(f.style) || 'pills', options: list(f.options || []).map(function (o) { return o.replace(/<br\s*\/?>/g, '').trim(); }).filter(Boolean),
      slots: Math.max(1, parseInt(f.slots, 10) || 1), max_mb: parseFloat(f.max_mb) || 5, tip: trim(f.tip),
      text: trim(f.text), maxlength: parseInt(f.maxlength, 10) || 0
    };
    return out;
  }
  cfg.gifts = (cfg.gifts || []).map(normGift).filter(function (g) { return g.key; });
  cfg.fields = (cfg.fields || []).map(normField);
  cfg.endpoint = trim(cfg.endpoint);

  /* ─────────────── state ─────────────── */
  var S = { employeeId: '', employee: null, verified: false, confirmed: false, giftKey: null, remoteGiftKey: null, values: {}, files: {}, submitted: false };

  /* ─────────────── elements ─────────────── */
  var $ = function (sel, el) { return (el || root).querySelector(sel); };
  var $$ = function (sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); };
  var E = {
    form: $('[data-kbl-form]'), closed: $('[data-kbl-closed]'), success: $('[data-kbl-success]'),
    step1: $('[data-kbl-step="1"]'), step2: $('[data-kbl-step="2"]'), step3: $('[data-kbl-step="3"]'),
    idInput: $('[data-kbl-id]'), verifyBtn: $('[data-kbl-verify]'), verifyLabel: $('[data-kbl-verify-label]'),
    okStatus: $('[data-kbl-status="ok"]'), errStatus: $('[data-kbl-status="err"]'), errText: $('[data-kbl-err-text]'),
    employee: $('[data-kbl-employee]'), confirmRow: $('[data-kbl-confirm-row]'), confirm: $('[data-kbl-confirm]'),
    step2Title: $('[data-kbl-step2-title]'), gifts: $('[data-kbl-gifts]'),
    fields: $('[data-kbl-fields]'), fieldsEmpty: $('[data-kbl-fields-empty]'),
    submit: $('[data-kbl-submit]'), submitLabel: $('[data-kbl-submit-label]'), submitErr: $('[data-kbl-submit-err]'),
    ctaNote: $('[data-kbl-cta-note]'), consent: $('[data-kbl-consent]'),
    deadlineText: $('[data-kbl-deadline-text]'), debug: $('[data-kbl-debug]'), debugPre: $('[data-kbl-debug-pre]')
  };

  var ICON_CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';
  var ICON_BRUSH = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9.06 11.9 8.07-8.06a2.85 2.85 0 1 1 4.03 4.03l-8.06 8.08"/><path d="M7.07 14.94c-1.66 0-3 1.35-3 3.02 0 1.33-2.5 1.52-2 2.02 1.08 1.1 2.49 2.02 4 2.02 2.2 0 4-1.8 4-4.04a3.01 3.01 0 0 0-3-3.02z"/></svg>';
  var ICON_CAMERA = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z"/><circle cx="12" cy="13" r="3"/></svg>';
  var ICON_BULB = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5"/><path d="M9 18h6"/><path d="M10 22h4"/></svg>';

  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };

  /* ─────────────── helpers ─────────────── */
  function setState(step, state) { if (step) step.setAttribute('data-state', state); }
  function busy(btn, label, on) {
    btn.disabled = on; btn.classList.toggle('is-busy', on);
    if (label) label.textContent = on ? (btn === E.verifyBtn ? (T.verifying || '…') : (T.submitting || '…')) : (btn === E.verifyBtn ? (T.verify_btn || '') : (T.submit || ''));
  }
  function showErr(el, msg) { if (!el) return; var t = el.querySelector('[data-kbl-err-text]') || el; t.textContent = msg; el.hidden = false; }
  function hide(el) { if (el) el.hidden = true; }

  function isClosed() {
    var d = trim(cfg.close_date); if (!d) return false;
    var m = d.match(/^(\d{4})-(\d{2})-(\d{2})$/); if (!m) return false;
    // Closes at the END of the given day, Israel time (UTC+2/+3 → use +3 to be lenient, never early).
    var end = Date.UTC(+m[1], +m[2] - 1, +m[3], 23, 59, 59) - 3 * 3600 * 1000;
    return Date.now() > end;
  }
  function showClosed() { E.form.hidden = true; E.closed.hidden = false; }

  function api(action, data) {
    var body = Object.assign({ action: action, project: cfg.project, page: cfg.page }, data || {});
    return fetch(cfg.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().catch(function () { return { ok: false, error: 'bad_json', status_code: r.status }; }); });
  }

  /* Remote config (Airtable bridge) can override gifts/fields/deadline — same JSON shape as the theme. */
  function applyRemote(r) {
    if (!r || typeof r !== 'object') return;
    if (Array.isArray(r.gifts) && r.gifts.length) cfg.gifts = r.gifts.map(normGift).filter(function (g) { return g.key; });
    if (Array.isArray(r.fields)) cfg.fields = r.fields.map(normField);
    if (r.deadline_text && E.deadlineText) E.deadlineText.textContent = r.deadline_text;
    if (r.close_date) cfg.close_date = r.close_date;
    if (r.gift_key) S.remoteGiftKey = trim(r.gift_key);
    if (r.closed === true || isClosed()) { showClosed(); return; }
    renderGifts();
  }

  /* ─────────────── step 1: verify ─────────────── */
  function resetVerification() {
    S.verified = false; S.employee = null; S.confirmed = false; S.giftKey = null;
    hide(E.okStatus); hide(E.errStatus); hide(E.employee); hide(E.confirmRow);
    if (E.confirm) E.confirm.checked = false;
    setState(E.step2, 'locked'); setState(E.step3, 'locked'); updateSubmit();
  }

  function verify() {
    var id = trim(E.idInput.value).replace(/\s+/g, '');
    hide(E.okStatus); hide(E.errStatus);
    if (id.length < 5) { E.idInput.setAttribute('aria-invalid', 'true'); showErr(E.errStatus, T.not_found); E.idInput.focus(); return; }
    E.idInput.removeAttribute('aria-invalid');
    busy(E.verifyBtn, E.verifyLabel, true);

    var p;
    if (cfg.endpoint) {
      p = api('verify', { employee_id: id });
    } else if (cfg.demo && cfg.demo.enabled) {
      p = new Promise(function (res) { setTimeout(function () {
        res(id === '000000000' ? { ok: false, error: 'not_found' } : { ok: true, status: 'open', employee: Object.assign({ id: id }, cfg.demo.employee) });
      }, 500); });
    } else {
      p = Promise.resolve({ ok: false, error: 'no_endpoint', message: 'העמוד עדיין לא מחובר למערכת. פנו לקופי בלוק.' });
    }

    p.then(function (r) {
      busy(E.verifyBtn, E.verifyLabel, false);
      if (!r || !r.ok) {
        var code = r && r.error;
        var msg = (r && r.message) || (code === 'already_submitted' ? T.already : code === 'closed' ? '' : T.not_found);
        if (code === 'closed') { showClosed(); return; }
        resetVerification(); showErr(E.errStatus, msg || T.network_err); return;
      }
      if (r.status === 'submitted' || r.already_submitted) { resetVerification(); showErr(E.errStatus, (r.message) || T.already); return; }
      S.employeeId = id; S.employee = r.employee || {}; S.verified = true;
      $$('[data-kbl-emp]').forEach(function (el) {
        var k = el.getAttribute('data-kbl-emp'); var v = trim(S.employee[k]);
        el.textContent = v;
        var row = el.closest('[data-kbl-emp-row]'); if (row) row.hidden = !v;
      });
      E.okStatus.hidden = false; E.employee.hidden = false; E.confirmRow.hidden = false;
      applyRemote(r); // may carry gifts / fields / gift_key for this employee
      E.confirm.focus();
    }).catch(function (err) {
      console.error('[kbl] verify failed', err);
      busy(E.verifyBtn, E.verifyLabel, false); showErr(E.errStatus, T.network_err);
    });
  }

  E.verifyBtn.addEventListener('click', verify);
  E.idInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); verify(); } });
  E.idInput.addEventListener('input', function () { if (S.verified) resetVerification(); });

  E.confirm.addEventListener('change', function () {
    S.confirmed = E.confirm.checked;
    if (S.confirmed) {
      setState(E.step2, 'open');
      renderGifts();
      var target = cfg.gifts.length > 1 ? E.step2 : E.step3;
      setTimeout(function () { target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 50);
    } else { setState(E.step2, 'locked'); setState(E.step3, 'locked'); }
    updateSubmit();
  });

  /* ─────────────── step 2: gifts ─────────────── */
  function availableGifts() { return cfg.gifts; }

  function renderGifts() {
    var gifts = availableGifts();
    var choice = gifts.length > 1;
    E.step2Title.textContent = choice ? (T.step2_multi || '') : (T.step2_single || '');
    E.gifts.classList.toggle('kbl-gifts--choice', choice);
    E.gifts.innerHTML = '';

    if (!gifts.length) {
      E.gifts.innerHTML = '<p class="kbl-gifts-note">לא הוגדרו מתנות לפרויקט הזה.</p>';
      return;
    }

    gifts.forEach(function (g, i) {
      var card = document.createElement(choice ? 'label' : 'div');
      card.className = 'kbl-gift ' + (choice ? 'kbl-gift--choice' : 'kbl-gift--single') + (g.sold_out ? ' kbl-gift--soldout' : '');
      card.setAttribute('data-gift', g.key);
      var img = g.image ? '<img src="' + esc(g.image) + '" alt="' + esc(g.title) + '" loading="lazy">' : '';
      card.innerHTML =
        (choice ? '<input type="radio" name="gift" value="' + esc(g.key) + '"' + (g.sold_out ? ' disabled' : '') + '>' : '') +
        '<div class="kbl-gift__inner">' +
          '<div class="kbl-gift__img">' + img + '</div>' +
          '<div class="kbl-gift__body">' +
            '<h3 class="kbl-gift__title">' + esc(g.title) + '</h3>' +
            (g.subtitle ? '<span class="kbl-gift__sub">' + esc(g.subtitle) + '</span>' : '') +
            (choice && g.badge ? '<span class="kbl-gift__badge">' + esc(g.badge) + '</span>' : '') +
            (!choice ? '<span class="kbl-gift__tag">' + ICON_BRUSH + esc(T.gift_tag || '') + '</span>' : '') +
          '</div>' +
        '</div>' +
        (choice && !g.sold_out ? '<span class="kbl-gift__radio" aria-hidden="true">' + ICON_CHECK + '</span>' : '') +
        (g.sold_out ? '<span class="kbl-gift__soldout">' + esc(T.sold_out || '') + '</span>' : '');
      E.gifts.appendChild(card);
    });

    if (!choice) {
      selectGift(gifts[0].sold_out ? null : gifts[0].key);
    } else {
      var pre = S.remoteGiftKey || S.giftKey;
      var preGift = pre && gifts.filter(function (g) { return g.key === pre && !g.sold_out; })[0];
      S.giftKey = null;
      if (preGift) { var inp = E.gifts.querySelector('input[value="' + CSS.escape(preGift.key) + '"]'); if (inp) { inp.checked = true; } selectGift(preGift.key); }
      else { setState(E.step3, S.confirmed ? 'locked' : 'locked'); E.fields.innerHTML = ''; hide(E.fieldsEmpty); }
      E.gifts.addEventListener('change', function (e) { if (e.target && e.target.name === 'gift') selectGift(e.target.value); });
    }
    updateSubmit();
  }

  function selectGift(key) {
    S.giftKey = key || null;
    $$('.kbl-gift--choice', E.gifts).forEach(function (c) { c.classList.toggle('is-selected', c.getAttribute('data-gift') === key); });
    if (!key) { setState(E.step3, 'locked'); updateSubmit(); return; }
    renderFields();
    if (S.confirmed) setState(E.step3, 'open');
    updateSubmit();
  }

  function currentGift() { return cfg.gifts.filter(function (g) { return g.key === S.giftKey; })[0] || null; }

  /* ─────────────── step 3: fields ─────────────── */
  function fieldsForGift(gift) {
    if (!gift) return [];
    if (gift.fields && gift.fields.length) return gift.fields; // remote per-gift schema wins
    return cfg.fields.filter(function (f) { return !f.gifts.length || f.gifts.indexOf(gift.key) !== -1; });
  }

  function renderFields() {
    var gift = currentGift(); var fields = fieldsForGift(gift);
    E.fields.innerHTML = '';
    E.fieldsEmpty.hidden = fields.length > 0;
    fields.forEach(function (f, i) { E.fields.appendChild(buildField(f, i)); });
  }

  function labelHtml(f, forId) {
    if (!f.label) return '';
    return '<label class="kbl-label"' + (forId ? ' for="' + forId + '"' : '') + '>' + esc(f.label) + (f.required ? '<span class="kbl-req" aria-hidden="true">*</span>' : '') + '</label>';
  }
  function hintHtml(f) { return f.hint ? '<p class="kbl-hint">' + esc(f.hint) + '</p>' : ''; }

  function buildField(f, i) {
    var wrap = document.createElement('div');
    wrap.className = 'kbl-field kbl-field--' + f.type; wrap.setAttribute('data-field', f.key);
    var id = 'kbl-f-' + i + '-' + f.key.replace(/[^\w-]/g, '_');
    var saved = S.values[f.key];
    var html = '';

    switch (f.type) {
      case 'textarea':
        html = labelHtml(f, id) + '<textarea class="kbl-textarea" id="' + id + '" placeholder="' + esc(f.placeholder) + '"' + (f.required ? ' required' : '') + '>' + esc(saved || '') + '</textarea>' + hintHtml(f);
        break;
      case 'select':
        if (f.style === 'dropdown') {
          html = labelHtml(f, id) + '<select class="kbl-select" id="' + id + '"' + (f.required ? ' required' : '') + '>' +
            '<option value="">' + esc(f.placeholder || T.select_placeholder || '') + '</option>' +
            f.options.map(function (o) { return '<option value="' + esc(o) + '"' + (saved === o ? ' selected' : '') + '>' + esc(o) + '</option>'; }).join('') +
            '</select>' + hintHtml(f);
        } else {
          html = labelHtml(f) + '<div class="kbl-pills" role="radiogroup" aria-label="' + esc(f.label) + '">' +
            f.options.map(function (o, j) { return '<label class="kbl-pill"><input type="radio" name="' + id + '" value="' + esc(o) + '"' + (saved === o ? ' checked' : '') + '><span>' + esc(o) + '</span></label>'; }).join('') +
            '</div>' + hintHtml(f);
        }
        break;
      case 'upload':
        html = labelHtml(f) + '<div class="kbl-upload" data-slots="' + f.slots + '"></div>' +
          (f.tip ? '<div class="kbl-tip">' + ICON_BULB + '<div><strong>טיפ:</strong> ' + esc(f.tip) + '</div></div>' : '') + hintHtml(f);
        break;
      case 'date':
        html = labelHtml(f, id) + '<input class="kbl-input" type="date" id="' + id + '" value="' + esc(saved || '') + '"' + (f.required ? ' required' : '') + '>' + hintHtml(f);
        break;
      case 'checkbox':
        html = labelHtml(f) + '<label class="kbl-check"><input type="checkbox" id="' + id + '"' + (saved ? ' checked' : '') + (f.required ? ' required' : '') + '><span class="kbl-check__box"></span><span>' + esc(f.text || f.label) + '</span></label>' + hintHtml(f);
        break;
      default: // text
        html = labelHtml(f, id) + '<input class="kbl-input" type="text" id="' + id + '" placeholder="' + esc(f.placeholder) + '" value="' + esc(saved || '') + '"' + (f.maxlength ? ' maxlength="' + f.maxlength + '"' : '') + (f.required ? ' required' : '') + '>' + hintHtml(f);
    }
    html += '<p class="kbl-field-err" role="alert"></p>';
    wrap.innerHTML = html;

    if (f.type === 'upload') buildUploadSlots(wrap.querySelector('.kbl-upload'), f);

    wrap.addEventListener('input', function () { S.values[f.key] = readValue(wrap, f); wrap.removeAttribute('data-invalid'); updateSubmit(); });
    wrap.addEventListener('change', function () { S.values[f.key] = readValue(wrap, f); wrap.removeAttribute('data-invalid'); updateSubmit(); });
    return wrap;
  }

  function readValue(wrap, f) {
    switch (f.type) {
      case 'select': if (f.style === 'dropdown') return wrap.querySelector('select').value; var c = wrap.querySelector('input[type=radio]:checked'); return c ? c.value : '';
      case 'checkbox': return wrap.querySelector('input[type=checkbox]').checked;
      case 'upload': return (S.files[f.key] || []).filter(Boolean).length;
      case 'textarea': return wrap.querySelector('textarea').value;
      default: return wrap.querySelector('input').value;
    }
  }

  /* Upload slots: one file input per slot, thumbnail preview, drag & drop, "+ add" reveals the next slot. */
  function buildUploadSlots(container, f) {
    S.files[f.key] = S.files[f.key] || [];
    var slots = [];
    for (var n = 0; n < f.slots; n++) slots.push(makeSlot(container, f, n));
    var add = null;
    if (f.slots > 1) {
      add = document.createElement('button'); add.type = 'button'; add.className = 'kbl-slot-add'; add.textContent = T.upload_add || '+';
      add.addEventListener('click', function () { var next = slots.filter(function (s) { return s.hidden; })[0]; if (next) { next.hidden = false; next.querySelector('input').click(); } refreshAdd(); });
      container.appendChild(add);
    }
    function refreshAdd() { if (add) add.hidden = !slots.some(function (s) { return s.hidden; }); }
    slots.forEach(function (s, n) { s.hidden = n > 0 && !S.files[f.key][n]; });
    refreshAdd();
    container._kblRefresh = refreshAdd; container._kblSlots = slots;
  }

  function makeSlot(container, f, n) {
    var slot = document.createElement('div'); slot.className = 'kbl-slot';
    var id = 'kbl-up-' + f.key.replace(/[^\w-]/g, '_') + '-' + n;
    slot.innerHTML = '<input type="file" id="' + id + '" accept="image/*,.heic,.heif">' +
      '<label class="kbl-dropzone" for="' + id + '" data-drop>' +
        '<span class="kbl-dropzone__icon">' + ICON_CAMERA + '</span>' +
        '<span class="kbl-dropzone__main">' + esc(T.upload_cta || '') + '</span>' +
        '<span class="kbl-dropzone__sub">' + esc((T.upload_formats || '').replace('5MB', f.max_mb + 'MB')) + '</span>' +
        '<img class="kbl-dropzone__preview" alt="">' +
        '<span class="kbl-dropzone__name"></span>' +
        '<button type="button" class="kbl-dropzone__clear" aria-label="הסרת התמונה">×</button>' +
      '</label>';
    var input = slot.querySelector('input'), zone = slot.querySelector('[data-drop]'), prev = slot.querySelector('.kbl-dropzone__preview'), name = slot.querySelector('.kbl-dropzone__name');

    function setFile(file) {
      var wrap = slot.closest('.kbl-field');
      if (file && file.size > f.max_mb * 1024 * 1024) {
        wrap.setAttribute('data-invalid', ''); wrap.querySelector('.kbl-field-err').textContent = (T.file_too_big || '').replace('{mb}', f.max_mb);
        input.value = ''; file = null;
      } else { wrap.removeAttribute('data-invalid'); }
      if (prev.src && prev.src.indexOf('blob:') === 0) URL.revokeObjectURL(prev.src);
      S.files[f.key][n] = file || null;
      zone.classList.toggle('has-file', !!file);
      if (file) { name.textContent = file.name; try { prev.src = URL.createObjectURL(file); } catch (e) { prev.removeAttribute('src'); } }
      else { name.textContent = ''; prev.removeAttribute('src'); }
      S.values[f.key] = S.files[f.key].filter(Boolean).length; updateSubmit();
    }
    input.addEventListener('change', function () { setFile(input.files && input.files[0]); });
    slot.querySelector('.kbl-dropzone__clear').addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation(); input.value = ''; setFile(null);
      if (n > 0) { slot.hidden = true; if (container._kblRefresh) container._kblRefresh(); }
    });
    ['dragenter', 'dragover'].forEach(function (ev) { zone.addEventListener(ev, function (e) { e.preventDefault(); zone.classList.add('is-over'); }); });
    ['dragleave', 'drop'].forEach(function (ev) { zone.addEventListener(ev, function (e) { e.preventDefault(); zone.classList.remove('is-over'); }); });
    zone.addEventListener('drop', function (e) {
      var files = Array.prototype.slice.call((e.dataTransfer && e.dataTransfer.files) || []).filter(function (x) { return /^image\//.test(x.type) || /\.(heic|heif)$/i.test(x.name); });
      if (!files.length) return;
      try { var dt = new DataTransfer(); dt.items.add(files[0]); input.files = dt.files; } catch (err) {}
      setFile(files[0]);
      // spill extra files into the next empty slots
      var rest = files.slice(1), slots = container._kblSlots || [];
      rest.forEach(function (file) {
        var target = slots.filter(function (s, i) { return i > n && !S.files[f.key][i]; })[0];
        if (!target) return; target.hidden = false;
        var inp = target.querySelector('input'); try { var d2 = new DataTransfer(); d2.items.add(file); inp.files = d2.files; } catch (err) {}
        inp.dispatchEvent(new Event('change', { bubbles: true }));
      });
      if (container._kblRefresh) container._kblRefresh();
    });
    container.appendChild(slot);
    return slot;
  }
  document.addEventListener('dragover', function (e) { if (root.querySelector('[data-drop]')) e.preventDefault(); });
  document.addEventListener('drop', function (e) { if (root.querySelector('[data-drop]')) e.preventDefault(); });

  /* ─────────────── validation + submit ─────────────── */
  function requiredMissing(f) {
    var v = S.values[f.key];
    if (f.type === 'upload') return !(S.files[f.key] || []).filter(Boolean).length;
    if (f.type === 'checkbox') return !v;
    return !trim(v);
  }
  function canSubmit() {
    if (!S.verified || !S.confirmed || !S.giftKey) return false;
    if (E.consent && !E.consent.checked) return false;
    var gift = currentGift(); if (!gift || gift.sold_out) return false;
    return !fieldsForGift(gift).some(function (f) { return f.required && requiredMissing(f); });
  }
  function updateSubmit() { E.submit.disabled = !canSubmit(); }
  if (E.consent) E.consent.addEventListener('change', updateSubmit);

  function validateAll() {
    var ok = true, first = null;
    fieldsForGift(currentGift()).forEach(function (f) {
      var wrap = E.fields.querySelector('[data-field="' + CSS.escape(f.key) + '"]'); if (!wrap) return;
      if (f.required && requiredMissing(f)) { ok = false; wrap.setAttribute('data-invalid', ''); wrap.querySelector('.kbl-field-err').textContent = T.required_err || ''; first = first || wrap; }
    });
    if (first) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return ok;
  }

  function buildPayload() {
    var gift = currentGift() || {};
    var fields = fieldsForGift(gift).map(function (f) {
      var entry = { key: f.key, label: f.label, type: f.type, airtable: f.airtable || null };
      if (f.type === 'upload') entry.files = (S.files[f.key] || []).map(function (file, i) { return file ? 'file_' + f.key + '_' + (i + 1) : null; }).filter(Boolean);
      else entry.value = S.values[f.key] == null ? '' : S.values[f.key];
      return entry;
    });
    return {
      action: 'submit', project: cfg.project, page: cfg.page,
      employee: Object.assign({ id: S.employeeId }, S.employee || {}),
      gift: { key: gift.key, title: gift.title, product_handle: gift.product_handle, variant_id: gift.variant_id, airtable_id: gift.airtable_id },
      fields: fields, consent: E.consent ? !!E.consent.checked : null,
      submitted_at: new Date().toISOString(), url: location.href
    };
  }

  function appendFiles(fd) {
    Object.keys(S.files).forEach(function (key) {
      var gift = currentGift(); if (!fieldsForGift(gift).some(function (f) { return f.key === key; })) return;
      (S.files[key] || []).forEach(function (file, i) { if (file) fd.append('file_' + key + '_' + (i + 1), file, file.name); });
    });
  }

  function submitEndpoint(payload) {
    var fd = new FormData(); fd.append('payload', JSON.stringify(payload)); appendFiles(fd);
    return fetch(cfg.endpoint, { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json().catch(function () { return { ok: r.ok }; }); });
  }

  /* Cart mode: the gift's variant + every answer as line-item properties → Shopify checkout.
   * Uses the existing Shopify→Airtable order sync. Employee identity travels as properties too. */
  function submitCart(payload) {
    var gift = currentGift();
    if (!gift.variant_id) return Promise.resolve({ ok: false, message: 'למתנה הזו לא מוגדר מוצר בחנות (variant_id).' });
    var fd = new FormData();
    fd.append('id', gift.variant_id); fd.append('quantity', '1');
    fd.append('properties[פרויקט B2B]', cfg.project || cfg.page || '');
    fd.append('properties[מספר עובד]', S.employeeId);
    fd.append('properties[שם העובד/ת]', trim((S.employee.first_name || '') + ' ' + (S.employee.last_name || '')));
    if (S.employee.department) fd.append('properties[מחלקה]', S.employee.department);
    payload.fields.forEach(function (f) {
      if (f.type === 'upload') { (S.files[f.key] || []).forEach(function (file, i) { if (file) fd.append('properties[' + f.label + (i ? ' ' + (i + 1) : '') + ']', file, file.name); }); }
      else if (f.type === 'checkbox') fd.append('properties[' + f.label + ']', f.value ? 'כן' : 'לא');
      else if (trim(f.value)) fd.append('properties[' + f.label + ']', f.value);
    });
    return fetch(window.routes && window.routes.cart_add_url ? window.routes.cart_add_url + '.js' : '/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { return r.ok ? { ok: true, redirect: cfg.discount_code ? '/discount/' + encodeURIComponent(cfg.discount_code) + '?redirect=/checkout' : '/checkout' } : { ok: false, message: j.description || j.message || T.network_err }; }); });
  }

  E.form.addEventListener('submit', function (e) {
    e.preventDefault();
    hide(E.submitErr);
    if (!canSubmit() || !validateAll()) { updateSubmit(); return; }
    var payload = buildPayload();
    busy(E.submit, E.submitLabel, true);

    var p;
    if (cfg.submit_mode === 'cart') p = submitCart(payload);
    else if (cfg.endpoint) p = submitEndpoint(payload);
    else if (cfg.demo && cfg.demo.enabled) p = new Promise(function (res) { setTimeout(function () { res({ ok: true, demo: true }); }, 600); });
    else p = Promise.resolve({ ok: false, message: 'העמוד עדיין לא מחובר למערכת.' });

    p.then(function (r) {
      if (r && r.ok) {
        if (r.redirect) { location.href = r.redirect; return; }
        S.submitted = true; E.form.hidden = true; E.success.hidden = false;
        if (r.demo && E.debug) {
          var dbg = Object.assign({}, payload, { _multipart_files: Object.keys(S.files).reduce(function (acc, k) { (S.files[k] || []).forEach(function (f, i) { if (f) acc['file_' + k + '_' + (i + 1)] = f.name + ' (' + Math.round(f.size / 1024) + 'KB)'; }); return acc; }, {}) });
          E.debugPre.textContent = JSON.stringify(dbg, null, 2); E.debug.hidden = false;
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        busy(E.submit, E.submitLabel, false); updateSubmit();
        E.submitErr.textContent = (r && r.message) || T.network_err; E.submitErr.hidden = false;
      }
    }).catch(function (err) {
      console.error('[kbl] submit failed', err);
      busy(E.submit, E.submitLabel, false); updateSubmit();
      E.submitErr.textContent = T.network_err; E.submitErr.hidden = false;
    });
  });

  /* ─────────────── boot ─────────────── */
  if (isClosed()) { showClosed(); return; }
  if (cfg.endpoint && cfg.load_remote_config) {
    api('config').then(applyRemote).catch(function (e) { console.warn('[kbl] remote config unavailable, using theme config', e); });
  }
  if (root.hasAttribute('data-design-mode')) { // theme editor: show everything so the merchant can style it
    setState(E.step2, 'open'); setState(E.step3, 'open'); E.employee.hidden = false; E.confirmRow.hidden = false; renderGifts();
    if (!S.giftKey && cfg.gifts[0]) selectGift(cfg.gifts[0].key);
  }
  updateSubmit();
})();
